// Copyright: IQGeo Limited 2010-2019
import _ from 'underscore';
import L from 'leaflet';
import myw from 'myWorld/base/core';
import 'L.VectorGrid';

/**
 *  @class Datasource to access visualization only layers
 *  @name GenericTilesDatasource
 */
myw.GenericTilesDatasource = myw.Datasource.extend('GenericTilesDatasource', {
    statics: {
        layerDefFields: [
            { name: 'relativeUrl', type: 'string', size: 'long' },
            { name: 'tileType', type: 'enumerator', enumerator: ['Raster', 'Vector'] },
            {
                name: 'extraOptions',
                type: 'json',
                viewClass: 'KeyValueView',
                args: { keyTitle: 'name', valueTitle: 'value', valType: 'json' }
            },
            { name: 'useCacheBust', type: 'boolean' }
        ],
        specFields: [{ name: 'baseUrl', type: 'string', size: 'long' }]
    },

    /**
     * Instantiates a leaflet layer from a layer definition
     * @param  {layerDefinition} layerDef
     * @return {ILayer}
     */
    createLayer(layerDef) {
        const tileAddressingScheme = layerDef.addressingScheme || '';
        let url = this.options.baseUrl + layerDef.relativeUrl + tileAddressingScheme;
        const layerDefFixedOptions = myw.Util.processOptionsFromJson(layerDef.extraOptions);
        const options = _.extend({}, layerDef.options, layerDefFixedOptions);

        if (layerDef.useCacheBust) {
            const separator = url.indexOf('?') > 0 ? '&' : '?';
            url += separator + Math.round(Math.random() * 1000000);
        }
        if (layerDef.tileType === 'Vector') {
            return new L.VectorGrid.Protobuf(url, options);
        }

        return new L.TileLayer(url, options);
    }
});

myw.datasourceTypes['generic_tiles'] = myw.GenericTilesDatasource;

export default myw.GenericTilesDatasource;
